import { MdsButton, MdsButtonVariant } from "@/design-system/components/button";
import { MdsIconButton, MdsIconButtonSize } from "@/design-system/components/icon-button";
import { MdsModal } from "@/design-system/components/modal";
import { MdsText, MdsTextSize, MdsTextWeight } from "@/design-system/components/text";
import { MdsIconKind } from "@/design-system/components/icon";
import styled from "@emotion/styled";

interface DeleteRecordingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteRecordingModal = ({ isOpen, onClose, onDelete }: DeleteRecordingModalProps) => {
  return (
    <MdsModal rootElementId="root" isModalOpen={isOpen} handleCloseModal={onClose}>
      <StyledContainer>
        <StyledHeader>
          <MdsText size={MdsTextSize.Large} weight={MdsTextWeight.SemiBold}>
            Delete recording
          </MdsText>
          <MdsIconButton
            iconKind={MdsIconKind.Exit}
            aria-label="Close"
            onClick={onClose}
            size={MdsIconButtonSize.Small}
          />
        </StyledHeader>
        <MdsText size={MdsTextSize.Small}>
          Are you sure you want to delete this recording and transcript? This cannot be undone.
        </MdsText>
        <StyledButtonRow>
          <MdsButton variant={MdsButtonVariant.Outlined} label="Cancel" onClick={onClose} />
          <MdsButton variant={MdsButtonVariant.Danger} label="Delete" onClick={onDelete} />
        </StyledButtonRow>
      </StyledContainer>
    </MdsModal>
  );
};

const StyledContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing.lg,
  gap: theme.spacing.sm,
  width: "min(600px, 90vw)",
  position: "relative",
}));

const StyledHeader = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing.sm,
}));

const StyledButtonRow = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: theme.spacing.sm,
}));
